export enum View {
  SelectView = "SelectView",
  MovedOutView = "MovedOutView",
  LeaseWillBeM2MView = "LeaseWillBeM2MView",
  LeaseDetailsView = "LeaseDetailsView",
  SuccessView = "SuccessView"
}

export enum SelectOption {
  MonthToMonth = "MonthToMonth",
  MovedOut = "MovedOut",
  NewLeaseEndDate = "NewLeaseEndDate",
  LeaseIsEnding = "LeaseIsEnding",
  LeaseWillBeM2M = "LeaseWillBeM2M"
}
